const API = {
  // Analytics
  ANALYTICS_FLOWS_LOGS: (params: string) => {
    const endpoint = '/api/v1/analytics/flows/logs/';
    const baseParams = `?bulk_result=True&exclude_nodes=True&`;
    return endpoint + baseParams + params;
  },
  ANALYTICS_FLOWS_NODE_CALLS: (params: string) => {
    const endpoint = '/api/v1/analytics/flows/node-calls/';
    const baseParams = `?bulk_result=True&`;
    return endpoint + baseParams + params;
  },
  ANALYTICS_FLOWS_NODE_CALLS_MONGO: (flowCallUuid: string) =>
    `/api/v1/analytics/flows/node-calls/?mongo_flow_ids=${flowCallUuid}&bulk_result=True`,
  ANALYTICS_ORGANIZATIONS_LOGS: (params: string) => {
    const endpoint = '/api/v1/analytics/organizations/logs/';
    const baseParams = `?bulk_result=True&exclude_nodes=True&`;
    return endpoint + baseParams + params;
  },
  ANALYTICS_ORGANIZATIONS_NODE_CALLS: (params: string) => {
    const endpoint = '/api/v1/analytics/organizations/node-calls/';
    const baseParams = `?bulk_result=True&`;
    return endpoint + baseParams + params;
  },
  ANALYTICS_SEARCH_EXECUTIONS: (params: string) =>
    `/api/v1/analytics/organizations/search-executions/?${params}`,
  ANALYTICS_PROJECTS_LOGS: (params: string) => {
    const endpoint = '/api/v1/analytics/projects/logs/';
    const baseParams = `?bulk_result=True&exclude_nodes=True&`;
    return endpoint + baseParams + params;
  },
  ANALYTICS_PROJECTS_NODE_CALLS: (params: string) => {
    const endpoint = '/api/v1/analytics/projects/node-calls/';
    const baseParams = `?bulk_result=True&`;
    return endpoint + baseParams + params;
  },

  // Billing
  BILLING_ORGANIZATIONS_LIST: () => '/api/v1/billing/organizations/',
  BILLING_ORGANIZATIONS_UPDATE: (organizationUuid: string) =>
    `/api/v1/billing/organizations/${organizationUuid}/`,
  BILLING_ORGANIZATIONS_REFRESH: (organizationUuid: string) =>
    `/api/v1/billing/organizations/${organizationUuid}/refresh/`,

  // Connections
  CONNECTIONS_CREATE: () => `/api/v1/connections/create/`,
  CONNECTIONS_DELETE: (connectionUuid: string) =>
    `/api/v1/connections/delete/${connectionUuid}/`,
  CONNECTIONS_UPDATE: (connectionUuid: string) =>
    `/api/v1/connections/update/${connectionUuid}/`,
  CONNECTIONS_DISCONNECT: (connection: string) =>
    `/api/v1/connections/${connection}/disconnect/`,
  CONNECTIONS_NODETYPE_LIST: (nodeTypeUuid: string, organizationUuid: string) =>
    `/api/v1/connections/nodetype/${nodeTypeUuid}/organization/${organizationUuid}/list/`,
  CONNECTIONS_VERIFY: (connection: string) =>
    `/api/v1/connections/${connection}/verify/`,

  // Core
  CORE_APP_INFO: () => '/api/v1/core/app-info/',
  CORE_TIMEZONES: () => '/api/v1/core/timezones/',
  CORE_ORGANIZATIONS_CONNECTIONS: (organizationUuid: string) =>
    `/api/v1/core/organizations/retrieve-connections/${organizationUuid}/`,
  CORE_ORGANIZATIONS_CREATE: () => '/api/v1/core/organizations/create/',
  CORE_ORGANIZATIONS_LEAVE: (organizationUuid: string) =>
    `/api/v1/core/organizations/${organizationUuid}/leave/`,
  CORE_ORGANIZATIONS_LIST: () => '/api/v1/core/organizations/list/',
  CORE_ORGANIZATIONS_PROFILE_LIST: () => '/api/v1/core/organizations/profile-list/',
  CORE_ORGANIZATIONS_UPDATE: (organizationUuid: string) =>
    `/api/v1/core/organizations/update/${organizationUuid}/`,
  CORE_ORGANIZATIONS_USERS_LIST: (organizationUuid: string) =>
    `/api/v1/core/organizations/${organizationUuid}/users/`,
  CORE_ORGANIZATIONS_USERS_UPDATE: (organizationUuid: string, userUuid: string) =>
    `/api/v1/core/organizations/${organizationUuid}/users/${userUuid}/`,
  CORE_ORGANIZATIONS_USERS_DELETE: (organizationUuid: string, userUuid: string) =>
    `/api/v1/core/organizations/${organizationUuid}/users/${userUuid}/`,
  CORE_ORGANIZATIONS_ARCHIVE: (organizationUuid: string) =>
    `/api/v1/core/organizations/archive/${organizationUuid}/`,
  CORE_ORGANIZATIONS_RESTORE: (organizationUuid: string) =>
    `/api/v1/core/organizations/restore/${organizationUuid}/`,
  CORE_ORGANIZATIONS_SCHEDULE_ARCHIVE: (organizationUuid: string) =>
    `/api/v1/core/organizations/schedule-archive/${organizationUuid}/`,
  CORE_ORGANIZATIONS_CANCEL_SCHEDULE_ARCHIVE: (organizationUuid: string) =>
    `/api/v1/core/organizations/cancel-schedule-archive/${organizationUuid}/`,
  CORE_PROJECTS_CREATE: () => '/api/v1/core/projects/create/',
  CORE_PROJECTS_LIST: (organizationUuid: string) =>
    `/api/v1/core/projects/list/?organization_uuids=${organizationUuid}`,
  CORE_PROJECTS_RETRIEVE: (projectUuid: string) =>
    `/api/v1/core/projects/retrieve/${projectUuid}/`,
  CORE_PROJECTS_PROFILE_LIST: () => '/api/v1/core/projects/profile-list/',
  CORE_PROJECTS_UPDATE: (projectUuid: string) => `/api/v1/core/projects/update/${projectUuid}/`,
  CORE_PROJECTS_ARCHIVE: (projectUuid: string) =>
    `/api/v1/core/projects/archive/${projectUuid}/`,
  CORE_PROJECTS_RESTORE: (projectUuid: string) =>
    `/api/v1/core/projects/restore/${projectUuid}/`,
  CORE_PROJECTS_SCHEDULE_ARCHIVE: (projectUuid: string) =>
    `/api/v1/core/projects/schedule-archive/${projectUuid}/`,
  CORE_PROJECTS_CANCEL_SCHEDULE_ARCHIVE: (projectUuid: string) =>
    `/api/v1/core/projects/cancel-schedule-archive/${projectUuid}/`,

  // Flows
  FLOWS_BUILDER_CONNECT_NODES: (sourceNodeUuid: string, targetNodeUuid: string) =>
    `/api/v1/flows/node/connect/${sourceNodeUuid}/${targetNodeUuid}/`,
  FLOWS_BUILDER_CREATE_NESTED_NODE: (parentNodeUuid: string) =>
    `/api/v1/flows/node/create-nested-node/${parentNodeUuid}/`,
  FLOWS_BUILDER_CREATE_ROOT_NODE: (flowUuid: string) =>
    `/api/v1/flows/create-root-node/${flowUuid}/`,
  FLOWS_BUILDER_DELETE_EDGE: (sourceNodeUuid: string, targetNodeUuid: string) =>
    `/api/v1/flows/node/disconnect/${sourceNodeUuid}/${targetNodeUuid}/`,
  FLOWS_BUILDER_DELETE_NODE: (nodeUuid: string) =>
    `/api/v1/flows/node/delete/${nodeUuid}/`,
  FLOWS_BUILDER_INSERT_NODE_BETWEEN: (sourceNodeUuid: string, targetNodeUuid: string) =>
    `/api/v1/flows/node/insert-between/${sourceNodeUuid}/${targetNodeUuid}/`,
  FLOWS_BUILDER_NODE_RESOURCES: () => `/api/v1/flows/node/resources/`,
  NODE_INPUT_DATA: (nodeUuid: string, fileIds: string[]) =>
    `/api/v1/flows/node/input-data/${nodeUuid}/?${fileIds
      .map((fileId: string) => `file_ids=${fileId}&`)
      .join('')}`,
  FLOWS_BUILDER_SET_NODE_ACTION: (nodeUuid: string, nodeActionUuid: string) =>
    `/api/v1/flows/node/set-action/${nodeUuid}/${nodeActionUuid}/`,
  FLOWS_BUILDER_SET_NODE_CONNECTION: (nodeUuid: string, nodeConnectionUuid: string) =>
    `/api/v1/flows/node/set-connection/${nodeUuid}/${nodeConnectionUuid}/`,
  FLOWS_BUILDER_SET_NODE_INPUT: (nodeUuid: string) =>
    `/api/v1/flows/node/set-input/${nodeUuid}/`,
  FLOWS_BUILDER_SET_NODE_TITLE: (nodeUuid: string) =>
    `/api/v1/flows/node/set-title/${nodeUuid}/`,
  FLOWS_BUILDER_SET_NODE_TYPE: (nodeUuid: string, nodeTypeUuid: string) =>
    `/api/v1/flows/node/set-type/${nodeUuid}/${nodeTypeUuid}/`,
  FLOWS_CREATE: (projectUuid: string) =>
    `/api/v1/core/projects/create-flow/${projectUuid}/`,
  FLOWS_COPY: (flowUuid: string) => `/api/v1/flows/copy/${flowUuid}/`,
  FLOWS_DELETE: (flowUuid: string) => `/api/v1/flows/delete/${flowUuid}/`,
  FLOWS_EXECUTE: (flowUuid: string) => `/api/v1/flows/execute/${flowUuid}/`,
  FLOWS_EXECUTE_FROM_NODE: (flowUuid: string) =>
    `/api/v1/flows/execute-from-node/${flowUuid}/`,
  FLOWS_EXECUTE_FROM_NODE_PREVIEW: (flowUuid: string) =>
    `/api/v1/flows/execute-from-node/${flowUuid}/preview/`,
  FLOWS_EXPORT: (flowUuid: string) => `/api/v1/flows/export/${flowUuid}/`,
  FLOWS_IMPORT: () => `/api/v1/flows/import/`,
  FLOWS_LIST: (projectUuid: string) =>
    `/api/v1/flows/list/?project_uuids=${projectUuid}`,
  FLOWS_RETRIEVE: (flowUuid: string) => `/api/v1/flows/retrieve/${flowUuid}/`,
  FLOWS_DETAIL: (flowUuid: string) => `/api/v1/flows/detail/${flowUuid}/`,
  FLOWS_SUBSTORE: (flowUuid: string, kind: 'settings' | 'data' | 'errors') =>
    `/api/v1/flows/substore/${flowUuid}/${kind}/`,
  FLOWS_SUBSTORE_ENTRY: (
    flowUuid: string,
    kind: 'settings' | 'data' | 'errors',
  ) => `/api/v1/flows/substore/${flowUuid}/${kind}/entry/`,
  FLOWS_SUBSTORE_DOWNLOAD: (
    flowUuid: string,
    kind: 'settings' | 'data' | 'errors',
  ) => `/api/v1/flows/substore/${flowUuid}/${kind}/download/`,
  FLOWS_DATA_STORE_DOWNLOAD: (flowUuid: string) =>
    `/api/v1/flows/data-store/${flowUuid}/download/`,
  FLOWS_UPDATE: (flowUuid: string) => `/api/v1/flows/update/${flowUuid}/`,
  PROJECTS_DATASTORE: (projectUuid: string) =>
    `/api/v1/projects/${projectUuid}/datastore/`,
  PROJECTS_SUBSTORE: (projectUuid: string, kind: 'settings' | 'data' | 'errors') =>
    `/api/v1/projects/${projectUuid}/substore/${kind}/`,

  // Mongo
  MONGO_FLOW_DATA: (fileIds: string[]) =>
    `/api/v1/mongo/flow-data/?${fileIds
      .map((fileId: string) => `file_ids=${fileId}&`)
      .join('')}`,

  // Nodetypes
  NODETYPES_ACTIONS_INPUT: (nodeActionUuid: string) =>
    `/api/v1/nodetypes/actions/${nodeActionUuid}/input/`,
  NODETYPES_ACTIONS_OUTPUT: (nodeActionUuid: string) =>
    `/api/v1/nodetypes/actions/${nodeActionUuid}/output/`,
  NODETYPES_CONNECTION: (nodeTypeUuid: string) =>
    `/api/v1/nodetypes/${nodeTypeUuid}/connection/`,

  // Users
  USERS_AUTHENTICATE: () => '/api/v1/users/authenticate/',
  USERS_CHANGE_PASSWORD: () => '/api/v1/users/change-password/',
  USERS_FORGOT_PASSWORD: () => '/api/v1/users/forgot-password/',
  USERS_LIST: () => '/api/v1/users/list/',
  USERS_LOGOUT: () => '/api/v1/users/logout/',
  USERS_REMOVE_AVATAR: () => '/api/v1/users/remove-avatar/',
  USERS_RESET_PASSWORD: (uuid: string, token: string) =>
    `/api/v1/users/reset-password/${uuid}/${token}/`,
  USERS_UPDATE_AVATAR: () => '/api/v1/users/update-avatar/',
  USERS_UPDATE_DATA: () => '/api/v1/users/update-data/',
  USERS_USER: () => '/api/v1/users/user/',

  // AI — diagnose (direct Anthropic API when the user stored a token,
  // claude.ai handoff otherwise) + the two key surfaces behind those modes.
  AI_DIAGNOSE: (nodeCallUuid: string) => `/api/v1/ai/diagnose/${nodeCallUuid}/`,
  AI_FLOW_EXPLAIN: (flowUuid: string) => `/api/v1/ai/flows/${flowUuid}/explain/`,
  AI_ANTHROPIC_KEY: () => '/api/v1/ai/settings/anthropic-key/',
  AI_HANDOFF_DIAGNOSE: (nodeCallUuid: string) => `/api/v1/ai/handoff/diagnose/${nodeCallUuid}/`,
  AI_HANDOFF_SETUP: () => '/api/v1/ai/handoff/setup/',
  USERS_ORGANIZATIONS_LIST: (userUuid: string) =>
    `/api/v1/users/${userUuid}/organizations/`,
  USERS_ORGANIZATIONS_DETAIL: (userUuid: string, organizationUuid: string) =>
    `/api/v1/users/${userUuid}/organizations/${organizationUuid}/`,

  // // Webhooks
  // WEBHOOKS: (organizationUuid: string) =>
  //   `/api/v1/organizations/${organizationUuid}/webhooks/`,
  // WEBHOOKS_ACTIVATE: (webhookUuid: string) =>
  //   `/api/v1/webhooks/${webhookUuid}/activate/`,
  // WEBHOOKS_DETAIL: (webhookUuid: string) => `/api/v1/webhooks/${webhookUuid}/`,
};

export default API;
